<template>
	<div class="border-ot px-2 mb-2">
		<!-- MAXIMILIANO: ACTIVAR SOLO EN LA LIST -->
		<!-- <div class="marca-agua">
			<img src="@/assets/rr-plagas.png" height="100px" />
		</div> -->
		<div class="d-flex block w-100 ">
			<div style="width: 340px; line-height: 1.1">
				<img src="@/assets/rr-plagas.png" style="height: 50px; width: 100%;" />
				<div class="ml-3" style="font-size: 8px !important; font-weight: 500">
					<SPAN>RR CONTROL DE PLAGAS SPA.</SPAN>
					<br />
					<SPAN>RUT: 76.454.646-6</SPAN>
					<br />
					<SPAN>RES. SAN Nª 15970 26/07/2017</SPAN>
					<br />
					<span>REP. LEG: NICOLÁS ROJAS URÍZAR 15.936.593-K</span>
					<br />
					<span>PASAJE MONTREAL 8435, LA FLORIDA, STGO</span>
					<br />
					<span>SUC. ORTUZAR 963, MELIPILLA.</span>
					<br />
					<span>TELEFONO: 228318060 </span>
				</div>
			</div>
			<div
				style="width: 400px; line-height: 1.1; text-align: center; padding-top: 60px; font-weight: 700"
				v-if="getUser.role === 'person'"
			>
				<span style="font-size: 25px;">ORDEN DE TRABAJO</span>
			</div>
			<div
				style="width: 400px; line-height: 1.1; text-align: center; padding-top: 60px; font-weight: 700"
				v-else
			>
				<span style="font-size: 25px;">CERTIFICADO</span>
			</div>
			<div style="width: 400px; line-height: 1.1; padding-top: 60px;  ">
				<div class="d-flex block w-100 mb-2 " style="justify-content: center;">
					<div style="width: 100px;" class="pa-1 pr-2 text-right">
						<span style="font-size: 16px;">Nº</span>
					</div>
					<div class="bb bt bl br pa-1" style="width: 100px;">
						Por definir
					</div>
				</div>
				<div class="d-flex block w-100" style="justify-content: center;">
					<div style="width: 100px;" class="pa-1 pr-2 text-right">
						<span style="font-size: 16px;">FECHA</span>
					</div>
					<div class="bb bt bl br pa-1" style="width: 100px;">
						{{ this.order.date }}
					</div>
				</div>
			</div>
		</div>
		<div>
			<div style="width: 100%;" class="text-center bb bt br bl mt-2 bg">
				<span
					style="color: white; font-size: 15px; font-weight: 500; line-height: 0.5 !important"
					>IDENTIFICACIÓN DE INMUEBLE TRATADO</span
				>
			</div>
			<div style="width: 100%;" class=" text-left bb br bl  pl-1">
				Nombre o Razón social:
				<input type="text" style="width:80%; " class="ml-2" v-model="order.data[0]" />
			</div>
			<div style="width: 100%;" class="d-flex text-left  ">
				<div style="width:60%;" class=" bb br bl pl-1">
					Dirección:
					<input type="text" style="width:70%;" class="ml-2" v-model="order.data[1]" />
				</div>
				<div style="width:40%;" class="bb br pl-1">
					Comuna:
					<input type="text" style="width:80%;" class="ml-2" v-model="order.data[2]" />
				</div>
			</div>
			<div style="width: 100%;" class="d-flex text-left  ">
				<div style="width:33%;" class="bb br bl pl-1">
					Propietario:
					<input type="text" style="width:60%;" class="ml-2" v-model="order.data[3]" />
				</div>
				<div style="width:33%;" class="bb br pl-1">
					Rut:
					<input type="text" style="width:60%;" class="ml-2" v-model="order.data[4]" />
				</div>
				<div style="width:34%;" class="bb br pl-1">
					Teléfono:
					<input type="text" style="width:60%;" class="ml-2" v-model="order.data[5]" />
				</div>
			</div>
			<div style="width: 100%;" class="d-flex text-left  ">
				<div style="width:33%;" class="bb br bl pl-1">
					Solicitante:
					<input type="text" style="width:60%;" class="ml-2" v-model="order.data[6]" />
				</div>
				<div style="width:33%;" class="bb br pl-1">
					Rut:
					<input type="text" style="width:60%;" class="ml-2" v-model="order.data[7]" />
				</div>
				<div style="width:34%;" class="bb br pl-1">
					Mail:
					<input type="text" style="width:60%;" class="ml-2" v-model="order.data[8]" />
				</div>
			</div>
		</div>
		<div>
			<div style="width: 100%;" class="text-center bb bt br bl mt-2 bg">
				<span
					style="color: white; font-size: 15px; font-weight: 500; line-height: 0.5 !important"
					>DESRATIZACIÓN</span
				>
			</div>
			<div style="width: 100%;" class="d-flex text-center  ">
				<div style="width:20%;" class="bb br bl pl-1">
					TIPO DE ROEDOR
				</div>
				<div style="width:40%;" class="bb br pl-1">
					PRODUCTO UTILIZADO 1
				</div>
				<div style="width:40%;" class="bb br pl-1">
					PRODUCTO UTILIZADO 2
				</div>
			</div>
			<div style="width: 100%; height: 260px" class="d-flex text-center  ">
				<div style="width:20%;" class=" bb br bl pl-1 pt-2">
					Especie
					<div class="d-flex">
						<input
							type="checkbox"
							style="width:40%;"
							class="ml-2 bb"
							v-model="order.data[30]"
						/>
						<div style="width:50%;" class="text-right">
							<span style="font-size: 10px;">Rattus norvegicus</span>
						</div>
					</div>
					<div class="d-flex">
						<input
							type="checkbox"
							style="width:40%;"
							class="ml-2 bb"
							v-model="order.data[31]"
						/>
						<div style="width:50%;" class="text-right">
							<span style=" font-size: 10px;">Rattus rattus</span>
						</div>
					</div>
					<div class="d-flex">
						<input
							type="checkbox"
							style="width:40%;"
							class="ml-2 bb"
							v-model="order.data[32]"
						/>
						<div style="width:50%;" class="text-right">
							<span style="font-size: 10px;">Mus musculus</span>
						</div>
					</div>
					<div style="width:100%;" class="bb bt mt-2 mb-2">
						REVISION
					</div>
					<div class="d-flex justify-end">
						<div style="width:20%;" class="text-right">
							<span style="font-size: 10px;">TOT</span>
						</div>
						<div style="width:20%;" class="text-right">
							<span style="font-size: 10px;">REV</span>
						</div>
						<div style="width:20%;" class="text-right">
							<span style="font-size: 10px;">ACT</span>
						</div>
					</div>
					<div class="d-flex">
						<div style="width:60%;" class="text-left">
							<span style="font-size: 10px;">ESTACIONES</span>
						</div>
						<input
							type="text"
							style="width:20%;"
							class="ml-2 bb"
							v-model="order.data[33]"
						/>
						<input
							type="text"
							style="width:20%;"
							class="ml-2 bb"
							v-model="order.data[34]"
						/>
						<input
							type="text"
							style="width:20%;"
							class="ml-2 bb"
							v-model="order.data[35]"
						/>
					</div>
					<div class="d-flex">
						<div style="width:60%;" class="text-left">
							<span style=" font-size: 10px;">TRAMPAS</span>
						</div>
						<input
							type="text"
							style="width:20%;"
							class="ml-2 bb"
							v-model="order.data[36]"
						/>
						<input
							type="text"
							style="width:20%;"
							class="ml-2 bb"
							v-model="order.data[37]"
						/>
						<input
							type="text"
							style="width:20%;"
							class="ml-2 bb"
							v-model="order.data[38]"
						/>
					</div>
					<div class="d-flex">
						<div style="width:60%;" class="text-left">
							<span style="font-size: 10px;">CAPTURA</span>
						</div>
						<input
							type="text"
							style="width:20%;"
							class="ml-2 bb"
							v-model="order.data[39]"
						/>
						<input
							type="text"
							style="width:20%;"
							class="ml-2 bb"
							v-model="order.data[40]"
						/>
						<input
							type="text"
							style="width:20%;"
							class="ml-2 bb"
							v-model="order.data[41]"
						/>
					</div>
				</div>
				<div style="width:40%;" class="bb br pl-1 pt-2">
					<div class="d-flex">
						<div style="width:30%;" class="text-left">
							<span style="font-size: 10px;">PRODUCTO</span>
						</div>
						<select
							name="product"
							style="width:65%;"
							class="ml-2 bb"
							v-model="itemsProductos[0].producto"
							@change="
								{
									resetValues(0);
									setSelectedValuesDefault(0, types[0]);
								}
							"
						>
							<option
								:value="option"
								v-for="(option, i) in getProducto(types[0])"
								:key="i"
								>{{ option }}</option
							>
						</select>
					</div>
					<div class="d-flex">
						<div style="width:30%;" class="text-left">
							<span style="font-size: 10px;">REGISTRO ISP</span>
						</div>
						<select
							name="isp"
							style="width:65%;"
							class="ml-2 bb"
							v-model="itemsProductos[0].isp"
						>
							<option
								:value="option"
								v-for="(option, i) in getIsp(types[0], itemsProductos[0].producto)"
								:key="i"
								>{{ option }}</option
							>
						</select>
					</div>
					<div class="d-flex">
						<div style="width:30%;" class="text-left">
							<span style="font-size: 10px;">INGREDIENTE ACTIVO</span>
						</div>
						<select
							name="ingredienteActivo"
							style="width:65%;"
							class="ml-2 bb"
							v-model="itemsProductos[0].ingredienteActivo"
						>
							<option
								:value="option"
								v-for="(option, i) in getIngredienteActivo(
									types[0],
									itemsProductos[0].producto
								)"
								:key="i"
								>{{ option }}</option
							>
						</select>
					</div>
					<div class="d-flex">
						<div style="width:30%;" class="text-left">
							<span style="font-size: 10px;">FORMULACIÓN</span>
						</div>
						<select
							name="formulation"
							style="width:65%;"
							class="ml-2 bb"
							v-model="itemsProductos[0].formulacion"
						>
							<option
								:value="option"
								v-for="(option, i) in getFormulacion(
									types[0],
									itemsProductos[0].producto
								)"
								:key="i"
								>{{ option }}</option
							>
						</select>
					</div>
					<div class="d-flex">
						<div style="width:30%;" class="text-left">
							<span style="font-size: 10px;">DOSIS</span>
						</div>
						<select
							name="dosis"
							style="width:65%;"
							class="ml-2 bb"
							v-model="itemsProductos[0].dosis"
						>
							<option
								:value="option"
								v-for="(option, i) in getDosis(
									types[0],
									itemsProductos[0].producto,
									itemsProductos[0].formulacion
								)"
								:key="i"
								>{{ option }}</option
							>
						</select>
					</div>
					<div class="d-flex">
						<div style="width:30%;" class="text-left">
							<span style="font-size: 10px;">CONCENTRACION</span>
						</div>
						<select
							name="concentracion"
							style="width:65%;"
							class="ml-2 bb"
							v-model="itemsProductos[0].concentracion"
						>
							<option
								:value="option"
								v-for="(option, i) in getConcentracion(
									types[0],
									itemsProductos[0].producto
								)"
								:key="i"
								>{{ option }}</option
							>
						</select>
					</div>
					<div class="d-flex">
						<div style="width:30%;" class="text-left">
							<span style="font-size: 10px;">NUMERO DE CEBOS</span>
						</div>
						<input
							name="formulation"
							style="width:65%;"
							class="ml-2 bb"
							v-model="itemsProductos[0].numeroCebos"
						/>
					</div>
					<div class="d-flex">
						<div style="width:30%;" class="text-left">
							<span style="font-size: 10px;">PESO DE CEBOS</span>
						</div>
						<select
							name="pesoCebo"
							style="width:65%;"
							class="ml-2 bb"
							v-model="itemsProductos[0].pesoCebo"
						>
							<option
								:value="option"
								v-for="(option, i) in getPesoCebo(
									types[0],
									itemsProductos[0].producto
								)"
								:key="i"
								>{{ option }}</option
							>
						</select>
					</div>
					<div class="d-flex">
						<div style="width:30%;" class="text-left">
							<span style="font-size: 10px;">ANTIDOTO</span>
						</div>
						<select
							name="antidoto"
							style="width:65%;"
							class="ml-2 bb"
							v-model="itemsProductos[0].antidoto"
						>
							<option
								:value="option"
								v-for="(option, i) in getAntidoto(
									types[0],
									itemsProductos[0].producto
								)"
								:key="i"
								>{{ option }}</option
							>
						</select>
					</div>
					<div class="d-flex">
						<v-btn small class="ma-2" @click="cleanSelects(0)">Limpiar campos</v-btn>
					</div>
				</div>
				<div style="width:40%;" class="bb br pl-1 pt-2">
					<div class="d-flex">
						<div style="width:30%;" class="text-left">
							<span style="font-size: 10px;">PRODUCTO</span>
						</div>
						<select
							name="product"
							style="width:65%;"
							class="ml-2 bb"
							v-model="itemsProductos[1].producto"
							@change="
								{
									resetValues(1);
									setSelectedValuesDefault(1, types[0]);
								}
							"
						>
							<option
								:value="option"
								v-for="(option, i) in getProducto(types[0])"
								:key="i"
								>{{ option }}</option
							>
						</select>
					</div>
					<div class="d-flex">
						<div style="width:30%;" class="text-left">
							<span style="font-size: 10px;">REGISTRO ISP</span>
						</div>
						<select
							name="isp"
							style="width:65%;"
							class="ml-2 bb"
							v-model="itemsProductos[1].isp"
						>
							<option
								:value="option"
								v-for="(option, i) in getIsp(types[0], itemsProductos[1].producto)"
								:key="i"
								>{{ option }}</option
							>
						</select>
					</div>
					<div class="d-flex">
						<div style="width:30%;" class="text-left">
							<span style="font-size: 10px;">INGREDIENTE ACTIVO</span>
						</div>
						<select
							name="ingredienteActivo"
							style="width:65%;"
							class="ml-2 bb"
							v-model="itemsProductos[1].ingredienteActivo"
						>
							<option
								:value="option"
								v-for="(option, i) in getIngredienteActivo(
									types[0],
									itemsProductos[1].producto
								)"
								:key="i"
								>{{ option }}</option
							>
						</select>
					</div>
					<div class="d-flex">
						<div style="width:30%;" class="text-left">
							<span style="font-size: 10px;">FORMULACIÓN</span>
						</div>
						<select
							name="formulation"
							style="width:65%;"
							class="ml-2 bb"
							v-model="itemsProductos[1].formulacion"
						>
							<option
								:value="option"
								v-for="(option, i) in getFormulacion(
									types[0],
									itemsProductos[1].producto
								)"
								:key="i"
								>{{ option }}</option
							>
						</select>
					</div>
					<div class="d-flex">
						<div style="width:30%;" class="text-left">
							<span style="font-size: 10px;">DOSIS</span>
						</div>
						<select
							name="dosis"
							style="width:65%;"
							class="ml-2 bb"
							v-model="itemsProductos[1].dosis"
						>
							<option
								:value="option"
								v-for="(option, i) in getDosis(
									types[0],
									itemsProductos[1].producto,
									itemsProductos[1].formulacion
								)"
								:key="i"
								>{{ option }}</option
							>
						</select>
					</div>
					<div class="d-flex">
						<div style="width:30%;" class="text-left">
							<span style="font-size: 10px;">CONCENTRACION</span>
						</div>
						<select
							name="concentracion"
							style="width:65%;"
							class="ml-2 bb"
							v-model="itemsProductos[1].concentracion"
						>
							<option
								:value="option"
								v-for="(option, i) in getConcentracion(
									types[0],
									itemsProductos[1].producto
								)"
								:key="i"
								>{{ option }}</option
							>
						</select>
					</div>
					<div class="d-flex">
						<div style="width:30%;" class="text-left">
							<span style="font-size: 10px;">NUMERO DE CEBOS</span>
						</div>
						<input
							name="formulation"
							style="width:65%;"
							class="ml-2 bb"
							v-model="itemsProductos[1].numeroCebos"
						/>
					</div>
					<div class="d-flex">
						<div style="width:30%;" class="text-left">
							<span style="font-size: 10px;">PESO DE CEBOS</span>
						</div>
						<select
							name="pesoCebo"
							style="width:65%;"
							class="ml-2 bb"
							v-model="itemsProductos[1].pesoCebo"
						>
							<option
								:value="option"
								v-for="(option, i) in getPesoCebo(
									types[0],
									itemsProductos[1].producto
								)"
								:key="i"
								>{{ option }}</option
							>
						</select>
					</div>
					<div class="d-flex">
						<div style="width:30%;" class="text-left">
							<span style="font-size: 10px;">ANTIDOTO</span>
						</div>
						<select
							name="antidoto"
							style="width:65%;"
							class="ml-2 bb"
							v-model="itemsProductos[1].antidoto"
						>
							<option
								:value="option"
								v-for="(option, i) in getAntidoto(
									types[0],
									itemsProductos[1].producto
								)"
								:key="i"
								>{{ option }}</option
							>
						</select>
					</div>
					<div class="d-flex">
						<v-btn small class="ma-2" @click="cleanSelects(1)">Limpiar campos</v-btn>
					</div>
				</div>
			</div>
			<div>
				<div style="width: 100%;" class="text-center bb bt br bl mt-2 bg">
					<span
						style="color: white; font-size: 15px; font-weight: 500; line-height: 0.5 !important"
						>DESINSECTACIÓN</span
					>
				</div>
				<div style="width: 100%;" class="d-flex text-center  ">
					<div style="width:20%;" class="bb br bl pl-1">
						TIPO DE INSECTO
					</div>
					<div style="width:40%;" class="bb br pl-1">
						PRODUCTO UTILIZADO 1
					</div>
					<div style="width:40%;" class="bb br pl-1">
						PRODUCTO UTILIZADO 2
					</div>
				</div>
				<div style="width: 100%; height: 250px" class="d-flex text-center  ">
					<div style="width:20%;" class=" bb br bl pl-1 pt-2">
						<div class="d-flex">
							<div style="width:50%;" class="text-center mr-2">
								<span style="font-size: 10px;">Nombre comun</span>
							</div>
							<div style="width:50%;" class="text-center ">
								<span style="font-size: 10px;">Nombre cientifico</span>
							</div>
						</div>
						<div class="d-flex">
							<select
								name="nombreComun1"
								style="width:50%;"
								class="ml-2 mr-2 bb"
								v-model="order.data[42]"
								@change="order.data[43] = especiesRrplagas[order.data[42]]"
							>
								<option
									:value="option"
									v-for="(option, i) in getEspecies()"
									:key="i"
									>{{ option }}</option
								>
							</select>
							<span style="font-size: 10px; width:50%;">{{ order.data[43] }}</span>
						</div>
						<div class="d-flex">
							<select
								name="nombreComun1"
								style="width:50%;"
								class="ml-2 mr-2 bb"
								v-model="order.data[44]"
								@change="order.data[45] = especiesRrplagas[order.data[44]]"
							>
								<option
									:value="option"
									v-for="(option, i) in getEspecies()"
									:key="i"
									>{{ option }}</option
								>
							</select>
							<span style="font-size: 10px; width:50%;">{{ order.data[45] }}</span>
						</div>
						<div class="d-flex">
							<select
								name="nombreComun1"
								style="width:50%;"
								class="ml-2 mr-2 bb"
								v-model="order.data[46]"
								@change="order.data[47] = especiesRrplagas[order.data[46]]"
							>
								<option
									:value="option"
									v-for="(option, i) in getEspecies()"
									:key="i"
									>{{ option }}</option
								>
							</select>
							<span style="font-size: 10px; width:50%;">{{ order.data[47] }}</span>
						</div>
						<div style="width:100%;" class="bb bt mt-5 mb-5">
							METODO
						</div>
						<div class="d-flex">
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[48]"
							/>
							<div style="width:80%;" class="text-left">
								<span style="font-size: 10px;">PULV. MANUAL</span>
							</div>
						</div>
						<div class="d-flex">
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[49]"
							/>
							<div style="width:80%;" class="text-left">
								<span style="font-size: 10px;">ULV</span>
							</div>
						</div>
						<div class="d-flex">
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[50]"
							/>
							<div style="width:80%;" class="text-left">
								<span style="font-size: 10px;">JERINGA</span>
							</div>
						</div>
					</div>
					<div style="width:40%;" class="bb br pl-1 pt-2">
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">PRODUCTO</span>
							</div>
							<select
								name="product"
								style="width:65%;"
								class="ml-2 bb"
								v-model="itemsProductos[2].producto"
								@change="
									{
										resetValues(2);
										setSelectedValuesDefault(2, types[1]);
									}
								"
							>
								<option
									:value="option"
									v-for="(option, i) in getProducto(types[1])"
									:key="i"
									>{{ option }}</option
								>
							</select>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">INGREDIENTE ACTIVO</span>
							</div>
							<select
								name="ingredienteActivo"
								style="width:65%;"
								class="ml-2 bb"
								v-if="itemsProductos[2].producto"
								v-model="itemsProductos[2].ingredienteActivo"
							>
								<option
									:value="option"
									v-for="(option, i) in getIngredienteActivo(
										types[1],
										itemsProductos[2].producto
									)"
									:key="i"
									>{{ option }}</option
								>
							</select>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">FORMULACIÓN</span>
							</div>
							<select
								name="formulation"
								style="width:65%;"
								class="ml-2 bb"
								v-if="
									getFormulacion(types[1], itemsProductos[2].producto)[0] !== '-'
								"
								v-model="itemsProductos[2].formulacion"
							>
								<option
									:value="option"
									v-for="(option, i) in getFormulacion(
										types[1],
										itemsProductos[2].producto
									)"
									:key="i"
									>{{ option }}</option
								>
							</select>
							<input
								name="formulation"
								style="width:65%;"
								class="ml-2 bb"
								v-else
								v-model="itemsProductos[2].formulacion"
							/>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">TIPO DE INSECTICIDA</span>
							</div>
							<select
								name="formulation"
								style="width:65%;"
								class="ml-2 bb"
								v-model="itemsProductos[2].tipo"
							>
								<option
									:value="option"
									v-for="(option, i) in getTipo(
										types[1],
										itemsProductos[2].producto
									)"
									:key="i"
									>{{ option }}</option
								>
							</select>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">DOSIS</span>
							</div>
							<select
								name="ingredienteActivo"
								style="width:65%;"
								class="ml-2 bb"
								v-if="
									getFormulacion(types[1], itemsProductos[2].producto)[0] !== '-'
								"
								v-model="itemsProductos[2].dosis"
							>
								<option
									:value="option"
									v-for="(option, i) in getDosis(
										types[1],
										itemsProductos[2].producto,
										itemsProductos[2].formulacion
									)"
									:key="i"
									>{{ option }}</option
								>
							</select>
							<input
								name="dosis"
								style="width:65%;"
								class="ml-2 bb"
								v-else
								v-model="itemsProductos[2].dosis"
							/>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">CONCENTRACION</span>
							</div>
							<select
								name="formulation"
								style="width:65%;"
								class="ml-2 bb"
								v-model="itemsProductos[2].concentracion"
							>
								<option
									:value="option"
									v-for="(option, i) in getConcentracion(
										types[1],
										itemsProductos[2].producto
									)"
									:key="i"
									>{{ option }}</option
								>
							</select>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">REGISTRO ISP</span>
							</div>
							<select
								name="isp"
								style="width:65%;"
								class="ml-2 bb"
								v-model="itemsProductos[2].isp"
							>
								<option
									:value="option"
									v-for="(option, i) in getIsp(
										types[1],
										itemsProductos[2].producto
									)"
									:key="i"
									>{{ option }}</option
								>
							</select>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">ANTIDOTO</span>
							</div>
							<select
								name="isp"
								style="width:65%;"
								class="ml-2 bb"
								v-model="itemsProductos[2].antidoto"
							>
								<option
									:value="option"
									v-for="(option, i) in getAntidoto(
										types[1],
										itemsProductos[2].producto
									)"
									:key="i"
									>{{ option }}</option
								>
							</select>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">CANTIDAD APLICADA</span>
							</div>
							<input
								name="cantidad-aplicada"
								style="width:65%;"
								class="ml-2 bb"
								v-model="itemsProductos[2].cantidadAplicada"
							/>
						</div>
						<div class="d-flex">
							<v-btn small class="ma-2" @click="cleanSelects(2)"
								>Limpiar campos</v-btn
							>
						</div>
					</div>
					<div style="width:40%;" class="bb br pl-1 pt-2">
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">PRODUCTO</span>
							</div>
							<select
								name="product"
								style="width:65%;"
								class="ml-2 bb"
								v-model="itemsProductos[3].producto"
								@change="
									{
										resetValues(3);
										setSelectedValuesDefault(3, types[1]);
									}
								"
							>
								<option
									:value="option"
									v-for="(option, i) in getProducto(types[1])"
									:key="i"
									>{{ option }}</option
								>
							</select>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">INGREDIENTE ACTIVO</span>
							</div>
							<select
								name="ingredienteActivo"
								style="width:65%;"
								class="ml-2 bb"
								v-model="itemsProductos[3].ingredienteActivo"
							>
								<option
									:value="option"
									v-for="(option, i) in getIngredienteActivo(
										types[1],
										itemsProductos[3].producto
									)"
									:key="i"
									>{{ option }}</option
								>
							</select>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">FORMULACIÓN</span>
							</div>
							<select
								name="formulation"
								style="width:65%;"
								class="ml-2 bb"
								v-if="
									getFormulacion(types[1], itemsProductos[3].producto)[0] !== '-'
								"
								v-model="itemsProductos[3].formulacion"
							>
								<option
									:value="option"
									v-for="(option, i) in getFormulacion(
										types[1],
										itemsProductos[3].producto
									)"
									:key="i"
									>{{ option }}</option
								>
							</select>
							<input
								name="formulation"
								style="width:65%;"
								class="ml-2 bb"
								v-else
								v-model="itemsProductos[3].formulacion"
							/>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">TIPO DE INSECTICIDA</span>
							</div>
							<select
								name="formulation"
								style="width:65%;"
								class="ml-2 bb"
								v-model="itemsProductos[3].tipo"
							>
								<option
									:value="option"
									v-for="(option, i) in getTipo(
										types[1],
										itemsProductos[3].producto
									)"
									:key="i"
									>{{ option }}</option
								>
							</select>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">DOSIS</span>
							</div>
							<select
								name="ingredienteActivo"
								style="width:65%;"
								class="ml-2 bb"
								v-if="
									getFormulacion(types[1], itemsProductos[3].producto)[0] !== '-'
								"
								v-model="itemsProductos[3].dosis"
							>
								<option
									:value="option"
									v-for="(option, i) in getDosis(
										types[1],
										itemsProductos[3].producto,
										itemsProductos[3].formulacion
									)"
									:key="i"
									>{{ option }}</option
								>
							</select>
							<input
								name="dosis"
								style="width:65%;"
								class="ml-2 bb"
								v-else
								v-model="itemsProductos[3].dosis"
							/>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">CONCENTRACION</span>
							</div>
							<select
								name="formulation"
								style="width:65%;"
								class="ml-2 bb"
								v-model="itemsProductos[3].concentracion"
							>
								<option
									:value="option"
									v-for="(option, i) in getConcentracion(
										types[1],
										itemsProductos[3].producto
									)"
									:key="i"
									>{{ option }}</option
								>
							</select>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">REGISTRO ISP</span>
							</div>
							<select
								name="isp"
								style="width:65%;"
								class="ml-2 bb"
								v-model="itemsProductos[3].isp"
							>
								<option
									:value="option"
									v-for="(option, i) in getIsp(
										types[1],
										itemsProductos[3].producto
									)"
									:key="i"
									>{{ option }}</option
								>
							</select>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">ANTIDOTO</span>
							</div>
							<select
								name="isp"
								style="width:65%;"
								class="ml-2 bb"
								v-model="itemsProductos[3].antidoto"
							>
								<option
									:value="option"
									v-for="(option, i) in getAntidoto(
										types[1],
										itemsProductos[3].producto
									)"
									:key="i"
									>{{ option }}</option
								>
							</select>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">CANTIDAD APLICADA</span>
							</div>
							<input
								name="cantidad-aplicada"
								style="width:65%;"
								class="ml-2 bb"
								v-model="itemsProductos[3].cantidadAplicada"
							/>
						</div>
						<div class="d-flex">
							<v-btn small class="ma-2" @click="cleanSelects(3)"
								>Limpiar campos</v-btn
							>
						</div>
					</div>
				</div>
			</div>
			<div>
				<div style="width: 100%; " class="d-flex  bt br bl mt-2 bg text-center  ">
					<div style="width:50%;" class="bb br pl-1">
						<span
							style="color: white; font-size: 15px; font-weight: 500; line-height: 0.5 !important"
						>
							SANITIZACIÓN
						</span>
					</div>

					<div style="width:50%;" class="bb br pl-1">
						<span
							style="color: white; font-size: 15px; font-weight: 500; line-height: 0.5 !important"
						>
							RECOMENDACIONES Y OBSERVACIONES
						</span>
					</div>
				</div>
				<div style="width: 100%; height: 350px" class="d-flex text-center  ">
					<div style="width:50%;" class="bb br bl pl-1 pt-2">
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">PRODUCTO</span>
							</div>
							<select
								name="product"
								style="width:65%;"
								class="ml-2 bb"
								v-model="itemsProductos[4].producto"
								@change="
									{
										resetValues(4);
										setSelectedValuesDefault(4, types[2]);
									}
								"
							>
								<option
									:value="option"
									v-for="(option, i) in getProducto(types[2])"
									:key="i"
									>{{ option }}</option
								>
							</select>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">INGREDIENTE ACTIVO</span>
							</div>
							<select
								name="ingredienteActivo"
								style="width:65%;"
								class="ml-2 bb"
								v-model="itemsProductos[4].ingredienteActivo"
							>
								<option
									:value="option"
									v-for="(option, i) in getIngredienteActivo(
										types[2],
										itemsProductos[4].producto
									)"
									:key="i"
									>{{ option }}</option
								>
							</select>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">FORMULACION</span>
							</div>
							<select
								name="FORMULACION"
								style="width:65%;"
								class="ml-2 bb"
								v-model="itemsProductos[4].formulacion"
							>
								<option
									:value="option"
									v-for="(option, i) in getFormulacion(
										types[2],
										itemsProductos[4].producto
									)"
									:key="i"
									>{{ option }}</option
								>
							</select>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">DOSIS</span>
							</div>
							<select
								name="dosis"
								style="width:65%;"
								class="ml-2 bb"
								v-model="itemsProductos[4].dosis"
							>
								<option
									:value="option"
									v-for="(option, i) in getDosis(
										types[2],
										itemsProductos[4].producto,
										itemsProductos[4].formulacion
									)"
									:key="i"
									>{{ option }}</option
								>
							</select>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">REGISTRO ISP</span>
							</div>
							<select
								name="isp"
								style="width:65%;"
								class="ml-2 bb"
								v-model="itemsProductos[4].isp"
							>
								<option
									:value="option"
									v-for="(option, i) in getIsp(
										types[2],
										itemsProductos[4].producto
									)"
									:key="i"
									>{{ option }}</option
								>
							</select>
						</div>
						<div class="d-flex">
							<div style="width:30%;" class="text-left">
								<span style="font-size: 10px;">CANTIDAD APLICADA</span>
							</div>
							<input
								name="cantidad-aplicada"
								style="width:65%;"
								class="ml-2 bb"
								v-model="itemsProductos[4].cantidadAplicada"
							/>
						</div>
						<div class="d-flex">
							<v-btn small class="ma-2" @click="cleanSelects(4)"
								>Limpiar campos</v-btn
							>
						</div>
					</div>
					<div style="width:50%;" class="bb br pl-1 pt-2">
						<div class="d-flex">
							Tipo de tratamiento
							<select
								name="formulation"
								style="width:65%;"
								class="ml-2 bb"
								v-model="observation.type"
							>
								<option
									:value="option"
									v-for="(option, i) in getTypesObservations"
									:key="i"
									:selected="option === 'sanitizado'"
									>{{ option }}</option
								>
							</select>
						</div>
						<p>Recomendaciones</p>
						<div
							class="d-flex"
							v-for="(item, i) in getRecomendaciones(observation.type)"
							:key="`recomendaciones ${i}`"
						>
							<input
								type="text"
								style="width:90%;"
								class="ml-2 mb-1"
								v-model="recomendacionesCustom[i]"
							/>
						</div>
						<div class="d-flex">
							<input
								type="text"
								style="width:90%;"
								class="ml-2 mb-1"
								v-model="observation.data[0]"
							/>
						</div>
						<p>Observaciones</p>
						<div
							class="d-flex"
							v-for="(item, i) in getObservaciones(observation.type)"
							:key="`observaciones ${i}`"
						>
							<!-- <span>{{ i + 1 }} {{ item }}</span> -->
							<input
								type="text"
								style="width:90%;"
								class="ml-2 mb-1"
								v-model="observaciones[i]"
							/>
						</div>

						<div class="d-flex">
							<input
								type="text"
								style="width:90%;"
								class="ml-2 mb-1"
								v-model="observation.data[1]"
							/>
						</div>
					</div>
				</div>
			</div>
			<div>
				<div style="width: 100%; " class="d-flex  bt br bl mt-2 bg text-center  ">
					<div style="width:30%;" class="bb br  pl-1">
						<span
							style="color: white; font-size: 15px; font-weight: 500; line-height: 0.5 !important"
						>
							LUGARES DE APLICACION
						</span>
					</div>
					<div style="width:35%;" class="bb br pl-1">
						<span
							style="color: white; font-size: 15px; font-weight: 500; line-height: 0.5 !important"
						>
							TIPO DE VISITA Y SERVICIO
						</span>
					</div>

					<div style="width:35%;" class="bb br pl-1">
						<span
							style="color: white; font-size: 15px; font-weight: 500; line-height: 0.5 !important"
						>
						</span>
					</div>
				</div>
				<div style="width: 100%; height: 350px" class="d-flex text-center  ">
					<div style="width:30%;" class=" bb br bl pl-1 pt-2">
						<div class="d-flex justify-end">
							<div style="width:20%;" class="text-left ">
								<span style="font-size: 10px;">ROED</span>
							</div>
							<div style="width:20%;" class="text-left ">
								<span style="font-size: 10px;">INSEC</span>
							</div>
							<div style="width:20%;" class="text-left ">
								<span style="font-size: 10px;">SANIT</span>
							</div>
						</div>
						<div class="d-flex">
							<div style="width:40%;" class="text-left">
								<span style="font-size: 10px;">INTERIOR</span>
							</div>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[51]"
							/>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[52]"
							/>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[53]"
							/>
						</div>
						<div class="d-flex">
							<div style="width:40%;" class="text-left">
								<span style="font-size: 10px;">EXTERIOR</span>
							</div>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[54]"
							/>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[55]"
							/>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[56]"
							/>
						</div>
						<div class="d-flex">
							<div style="width:40%;" class="text-left">
								<span style="font-size: 10px;">CASINO/COCINA</span>
							</div>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[57]"
							/>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[58]"
							/>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[59]"
							/>
						</div>
						<div class="d-flex">
							<div style="width:40%;" class="text-left">
								<span style="font-size: 10px;">OFICINAS</span>
							</div>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[60]"
							/>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[61]"
							/>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[62]"
							/>
						</div>
						<div class="d-flex">
							<div style="width:40%;" class="text-left">
								<span style="font-size: 10px;">BAÑOS/CAMARIN</span>
							</div>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[63]"
							/>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[64]"
							/>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[65]"
							/>
						</div>
						<div class="d-flex">
							<div style="width:40%;" class="text-left">
								<span style="font-size: 10px;">ESTANQUES</span>
							</div>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[66]"
							/>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[67]"
							/>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[68]"
							/>
						</div>
						<div class="d-flex">
							<div style="width:40%;" class="text-left">
								<span style="font-size: 10px;">BODEGAS</span>
							</div>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[69]"
							/>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[70]"
							/>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[71]"
							/>
						</div>
						<div class="d-flex">
							<div style="width:40%;" class="text-left">
								<span style="font-size: 10px;">SALA DE VENTAS</span>
							</div>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[72]"
							/>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[73]"
							/>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[74]"
							/>
						</div>
						<div class="d-flex">
							<input type="text" style="width:40%;" v-model="order.data[87]" />
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[75]"
							/>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[76]"
							/>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[77]"
							/>
						</div>
						<div class="d-flex">
							<input type="text" style="width:40%;" v-model="order.data[88]" />
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[78]"
							/>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[79]"
							/>
							<input
								type="checkbox"
								style="width:20%;"
								class="ml-2 br mr-2 bb"
								v-model="order.data[80]"
							/>
						</div>
					</div>
					<div style="width:35%;" class="bb br pl-1 pt-2">
						<div class="d-flex">
							<input type="checkbox" style="width:20%;" v-model="order.data[81]" />
							<div style="width:40%;" class="text-left">
								<span style="font-size: 10px;">INICIAL</span>
							</div>
						</div>
						<div class="d-flex">
							<input type="checkbox" style="width:20%;" v-model="order.data[82]" />
							<div style="width:40%;" class="text-left">
								<span style="font-size: 10px;">MANTENCION</span>
							</div>
						</div>
						<div class="d-flex">
							<input type="checkbox" style="width:20%;" v-model="order.data[83]" />
							<div style="width:40%;" class="text-left">
								<span style="font-size: 10px;">EXTRA</span>
							</div>
						</div>
						<div class="d-flex">
							<input type="checkbox" style="width:20%;" v-model="order.data[84]" />
							<div style="width:40%;" class="text-left">
								<span style="font-size: 10px;">MONITOREO</span>
							</div>
						</div>
						<div class="d-flex">
							<input type="checkbox" style="width:20%;" v-model="order.data[85]" />
							<div style="width:40%;" class="text-left">
								<span style="font-size: 10px;">CONTROL DE PLAGA</span>
							</div>
						</div>
						<div class="d-flex">
							<input type="checkbox" style="width:20%;" v-model="order.data[86]" />
							<div style="width:40%;" class="text-left">
								<span style="font-size: 10px;">DIAGNOSTICO</span>
							</div>
						</div>
						<div class="d-flex">
							<div style="width:40%;" class="text-left ml-2">
								<span style="font-size: 10px;">INICIO TRATAMIENTO</span>
							</div>
							<input
								type="text"
								style="width:25%;"
								class="ml-2 bb"
								v-model="order.start"
							/>
						</div>
						<div class="d-flex">
							<div style="width:40%;" class="text-left ml-2">
								<span style="font-size: 10px;">TERMINO TRATAMIENTO</span>
							</div>
							<input
								type="text"
								style="width:25%;"
								class="ml-2 bb"
								v-model="order.end"
							/>
						</div>
						<div class="d-flex">
							<div style="width:40%;" class="text-left ml-2">
								<span style="font-size: 10px;">VIGENCIA TRATAMIENTO</span>
							</div>
							<select
								name="vigencia"
								style="width:25%;"
								class="ml-2 bb"
								v-model="order.vigencia"
								@change="e => changeVigencia(e.target.value)"
							>
								<option v-for="(option, j) in optionsVigencia" :key="j">{{
									option
								}}</option>
							</select>
							<span> dias</span>
						</div>
						<div class="d-flex">
							<div style="width:40%;" class="text-left ml-2">
								<span style="font-size: 10px;">HORA INICIO TRATAMIENTO</span>
							</div>
							<input
								type="text"
								style="width:25%;"
								class="ml-2 bb"
								v-model="order.startHour"
							/>
						</div>
						<div class="d-flex">
							<div style="width:40%;" class="text-left ml-2">
								<span style="font-size: 10px;">HORA TERMINO TRATAMIENTO</span>
							</div>
							<input
								type="text"
								style="width:25%;"
								class="ml-2 bb"
								v-model="order.endHour"
							/>
						</div>
					</div>
					<div style="width:35%; font-size: 10px !important;" class="bb br pl-1 pt-2">
						<div class="d-flex">
							<span class="text-left"
								>RR CONTROL DE PLAGAS NO SE HACE RESPONSABLE POR POSIBLES
								RE-INFESTACIONES A FALTA DE CONDICIONES BASICAS DE SANEAMIENTO Y/O
								AL INCUMPLIMIENTO DE LAS RECOMENDACIONES TECNICAS
							</span>
						</div>
						<br />
						<div class="d-flex">
							<span class="text-left"
								>RR CONTROL DE PLAGAS NO REALIZARA NINGUN TIPO DE LABOR CUANDO SE
								ENCUENTREN PRESENTES PERSONAS AJENAS A LA EMPRESA, A MENOS QUE
								CUENTEN CON TODOS SUS IMPLEMENTOS DE PROTECCION PERSONAL
							</span>
						</div>
					</div>
				</div>
			</div>

			<div>
				<div v-if="getUser.role === 'admin' || getUser.role === 'superUser'">
					<div class="contenedor-firma-cliente" v-if="order.firma">
						<div class="background-primary text-center  subtitle-2 mt-6">
							Firma cliente
						</div>
						<div
							class="d-flex justify-space-between align-center"
							style="border: 1px solid #212121"
						>
							<div class=" text-left ml-2">
								<img class="firma-cliente" :src="order.firma" alt="firma-cliente" />
							</div>
						</div>
					</div>
				</div>
				<div v-else>
					<canvas-draw />
					<div style="width: 30%;">
						<div class="d-flex">
							<div style="width:20%;" class="text-left">
								<span style="width:20%;">
									Nombre:
								</span>
							</div>
							<input
								type="text"
								style="width:80%;"
								class="ml-2 bb"
								v-model="order.cliente.nombre"
							/>
						</div>
						<div class="d-flex">
							<div style="width:20%;" class="text-lef">
								<span style="width:20%;">
									Rut:
								</span>
							</div>
							<input
								type="text"
								style="width:80%;"
								class="ml-2 bb"
								v-model="order.cliente.rut"
							/>
						</div>
					</div>
				</div>
				<div style="width: 30%;">
					<div class="d-flex">
						<div style="width:20%;" class="text-left">
							<span style="width:20%;">
								Correo:
							</span>
						</div>
						<input
							type="text"
							style="width:80%;"
							class="ml-2 bb"
							v-model="order.correo"
						/>
					</div>
				</div>
			</div>
		</div>
		<div v-if="getUser.role === 'person'">
			<v-btn color="primary" :loading="loading" class="ma-1" @click="onSubmit">
				Guardar y enviar correo
			</v-btn>
		</div>
		<div v-else>
			<v-btn
				color="success"
				:loading="loading"
				class="ma-1 btn btn-default"
				@click="sendCertify"
			>
				CERTIFICAR
			</v-btn>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import optionsFormulacion from '../../assets/rrplagas/optionsFormulacion.json';
import recomendationsRrplagas from '../../assets/rrplagas/recomendationsRrplagas.json';
import especiesRrplagas from '../../assets/rrplagas/especiesRrplagas.json';
import moment from 'moment';

export default {
	components: {
		CanvasDraw: () => import('@/components/ui/CanvasDraw'),
	},
	props: {
		close: {
			type: Function,
		},
		idLodging: {
			type: String,
		},
	},
	data() {
		return {
			order: {
				date: undefined,
				data: [],
				id: undefined,
				user: undefined,
				tecnico: undefined,
				correo: undefined,
				imagen: { date: undefined, image: undefined },
				type: 'rrplagas',
				firma: '',
				start: '',
				end: '',
				cliente: { nombre: undefined, rut: undefined },
				vigencia: '',
			},
			loading: false,
			image: null,
			values: [],
			itemsLugarTratado: [],
			itemsPlagas: [],
			itemsEspecies: [],
			lodgingId: undefined,
			indexWorkOrder: undefined,
			especiesRrplagas,
			optionsFormulacion,
			recomendationsRrplagas,
			types: ['Rodenticida', 'Insecticida', 'Sanitizante'],
			optionsVigencia: ['1 dias', '7 dias', '15 dias', '30 dias', '60 dias', '90 dias'],
			itemsProductos: [],
			observation: { type: '', data: [], customObservaciones: [], customRecomendaciones: [] },
			observaciones: [],
			recomendacionesCustom: [],
		};
	},
	computed: {
		getTypes() {
			return Object.keys(this.optionsFormulacion);
		},
		getTypesObservations() {
			return Object.keys(this.recomendationsRrplagas);
		},
		...mapGetters({
			getUser: 'User/profile',
			lodgingSelect: 'Lodging/lodgingSelect',
			firmaString: 'Lodging/firma',
		}),
	},
	mounted() {
		this.lodgingId = this.$route.params.idLodging;
		this.indexWorkOrder = this.$route.params.index;
		if (this.lodgingId) {
			this.getWorkOrder({
				idLodging: this.lodgingId,
				indexWorkOrder: this.indexWorkOrder,
			}).then(data => {
				this.order = data.workOrder;
				this.itemsProductos = data.workOrder.data[20];
				this.observation = data.workOrder.data[21];
				this.order.data = data.workOrder.data;
				this.order.firma = data.workOrder.firma;
				this.order.correo = data.workOrder.correo;
				this.place = data.place;
				this.images = data.documents.filter(document => {
					const typeDocument = document.url.slice(-3);
					if (this.validateImage(typeDocument)) return true;
					return false;
				});
			});
		}
	},
	created() {
		document.getElementById('viewport').setAttribute('content', 'width=1200');
		if (this.lodgingSelect) this.setValuesDefault();
	},
	methods: {
		changeVigencia(e) {
			this.order.vigencia = e;
			const day = e.slice(0, 2);
			const newDate = this.lodgingSelect
				? moment(this.lodgingSelect.start)
						.add(day, 'days')
						.format('DD/MM/YY')
				: moment(this.order.start, 'DD/MM/YY')
						.add(day, 'days')
						.format('DD/MM/YY');
			this.order.end = newDate;
		},
		getEspecies() {
			return Object.keys(this.especiesRrplagas);
		},
		getProducto(type) {
			if (type) return Object.keys(this.optionsFormulacion[type]);
			return [''];
		},
		getIngredienteActivo(type, product) {
			if (type && product) return this.optionsFormulacion[type][product].ingredienteActivo;
			return [''];
		},
		getIsp(type, product) {
			if (type && product) return this.optionsFormulacion[type][product].isp;
			return [''];
		},
		getFormulacion(type, product) {
			if (type && product)
				return Object.keys(this.optionsFormulacion[type][product].metodologia);
			return [''];
		},
		getConcentracion(type, product) {
			if (type && product) return this.optionsFormulacion[type][product].concentracion;
			return [''];
		},
		getAntidoto(type, product) {
			if (type && product) return this.optionsFormulacion[type][product].antidoto;
			return [''];
		},
		getTipo(type, product) {
			if (type && product) return this.optionsFormulacion[type][product].tipo;
			return [''];
		},
		getPesoCebo(type, product) {
			if (type && product) return this.optionsFormulacion[type][product].pesoCebo;
			return [''];
		},
		getDosis(type, product, formulacion) {
			if (type && product && formulacion)
				return this.optionsFormulacion[type][product].metodologia[formulacion].dosis;
			return [''];
		},
		getObservaciones(observationType) {
			if (observationType) {
				this.observaciones = this.recomendationsRrplagas[observationType].observaciones;
				return this.observaciones;
			}
		},
		getRecomendaciones(observationType) {
			if (observationType) {
				this.recomendacionesCustom = this.recomendationsRrplagas[
					observationType
				].recomendaciones;
				return this.recomendacionesCustom;
			}
		},
		resetValues(index) {
			this.itemsProductos[index].formulacion = '';
			this.itemsProductos[index].dosis = '';
			this.itemsProductos[index].cantidadAplicada = '';
		},
		cleanSelects(index) {
			this.itemsProductos[index].ingredienteActivo = '';
			this.itemsProductos[index].producto = '';
			this.itemsProductos[index].formulacion = '';
			this.itemsProductos[index].ingredienteActivo = '';
			this.itemsProductos[index].metodologia = '';
			this.itemsProductos[index].isp = '';
			this.itemsProductos[index].dosis = '';
			this.itemsProductos[index].numeroCebos = '';
			this.itemsProductos[index].cebosDañados = '';
			this.itemsProductos[index].cebosPerdidos = '';
		},
		setSelectedValuesDefault(index, type) {
			const product = this.itemsProductos[index].producto;
			this.itemsProductos[index].ingredienteActivo = this.optionsFormulacion[type][
				product
			]?.ingredienteActivo?.[0];
			this.itemsProductos[index].formulacion = Object.keys(
				this.optionsFormulacion[type][product]?.metodologia
			)?.[0];
			this.itemsProductos[index].tipo = this.optionsFormulacion[type][product]?.tipo?.[0];
			this.itemsProductos[index].dosis = this.optionsFormulacion[type][product]?.metodologia[
				this.itemsProductos[index].formulacion
			].dosis?.[0];
			this.itemsProductos[index].concentracion = this.optionsFormulacion[type][
				product
			]?.concentracion?.[0];
			this.itemsProductos[index].antidoto = this.optionsFormulacion[type][
				product
			]?.antidoto?.[0];
			this.itemsProductos[index].isp = this.optionsFormulacion[type][product]?.isp?.[0];
			this.itemsProductos[index].pesoCebo = this.optionsFormulacion[type][
				product
			]?.pesoCebo?.[0];
		},
		lugarTratado() {
			return { name: '', int: false, ext: false, dr: false, ds: false, sn: false, o: false };
		},
		productos() {
			return {
				producto: '',
				formulacion: '',
				ingredienteActivo: '',
				metodologia: '',
				isp: '',
				dosis: '',
				numeroCebos: '',
				cebosDañados: '',
				cebosPerdidos: '',
			};
		},
		especie() {
			return { especie: '', identificacion: '', boolean: false };
		},
		pushLugarTratado() {
			this.itemsLugarTratado.push(this.lugarTratado());
		},
		popLugarTratado() {
			this.itemsLugarTratado.pop();
		},
		pushProductos() {
			this.itemsProductos.push(this.productos());
			this.itemsProductos.push(this.productos());
			this.itemsProductos.push(this.productos());
			this.itemsProductos.push(this.productos());
			this.itemsProductos.push(this.productos());
			this.itemsProductos.push(this.productos());
		},
		popPlaguicida() {
			this.itemsPlagas.pop();
		},
		pushEspecie() {
			this.itemsEspecies.push(this.especie());
		},
		popEspecie() {
			this.itemsEspecies.pop();
		},
		handleEspeciesSelectChange(e, i) {
			this.itemsEspecies[i].especie = e;
		},
		async onSubmit() {
			// valores libres si se requiere agregar mas inputs usarlos 0-5 y 33-42
			this.loading = true;

			// establecemos valores de los arrays dinamicos
			this.order.imagen.date = new Date();
			this.order.firma = this.firmaString;
			this.order.data[20] = this.itemsProductos;
			this.order.data[21] = this.observation;
			this.order.tecnico = this.getUser.idPerson;
			const data = JSON.stringify(this.order);
			const payload = new FormData();
			payload.append('image', this.image);
			payload.append('order', data);
			await this.createWorkOrder({
				idLodging: this.idLodging,
				payload,
			});
			this.loading = false;
			this.close();
		},
		setImage(event) {
			this.image = event.target.files[0];
		},
		setValuesDefault() {
			for (var i = 0; i < 90; i++) {
				this.order.data.push(null);
			}

			const todayHistory = this.filterTodayHistory(this.lodgingSelect.histories);

			this.order.data[3] = this.lodgingSelect.place.nombreCliente;
			this.order.data[4] = this.lodgingSelect.place.rutCliente;
			this.order.data[5] = this.lodgingSelect.place.telefonoGeneral;
			this.order.data[6] = this.lodgingSelect.place.nombreSolicitante;
			this.order.data[7] = this.lodgingSelect.place.rutSolicitante;
			this.order.data[8] = this.lodgingSelect.place.email[0];
			this.order.data[0] = this.lodgingSelect.place.name;
			this.order.data[1] = this.lodgingSelect.place.direction;
			this.order.data[2] = this.lodgingSelect.place.city;
			this.order.date = moment().format('DD/MM/YY');
			this.order.start = moment(this.lodgingSelect.start).format('DD/MM/YY');
			this.order.startHour = todayHistory ? moment(todayHistory.in).format('HH:mm') : '';
			this.order.endHour = moment().format('HH:mm');
			this.order.firma = this.firmaString;
			// Establecemos los arrays dinamicos con valores por defecto
			this.pushLugarTratado();
			this.pushProductos();
			this.pushEspecie();
		},
		filterTodayHistory(histories) {
			return histories.find(history => {
				const checkIn = moment(history.in);
				const today = moment();
				if (today.isSame(checkIn, 'day')) return history;
			});
		},
		async sendCertify() {
			// valores libres si se requiere agregar mas inputs usarlos 0-5 y 33-42
			this.loading = true;
			// establecemos valores de los arrays dinamicos
			this.order.imagen.date = new Date();
			this.order.data[20] = this.itemsProductos;
			this.observation.customObservaciones = this.observaciones;
			this.observation.customRecomendaciones = this.recomendacionesCustom;
			this.order.data[21] = this.observation;
			this.order.type = 'rrplagas-certificate';
			const data = JSON.stringify(this.order);
			const payload = new FormData();
			payload.append('image', this.image);
			payload.append('order', data);
			await this.certifyWorkOrder({
				idLodging: this.lodgingId,
				payload,
			});
			await this.fetchPlace();
			this.loading = false;
			this.$router.push({ name: 'places' });
		},
		...mapActions({
			createWorkOrder: 'Lodging/createWorkOrder',
			certifyWorkOrder: 'Lodging/certifyWorkOrder',
			getWorkOrder: 'Lodging/getWorkOrder',
			fetchPlace: 'Place/fetchPlace',
		}),
	},
};
</script>

<style scoped>
input {
	height: 18px;
	border: 1px solid gray;
	background-color: #a2850721;
}

select {
	background-color: #a2850721;
	height: 18px;
	border: 1px solid gray;
}
.nw {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.marca-agua {
	position: absolute;
	top: 40%;
	left: 15%;
	opacity: 0.2;
	z-index: 1;
}
* {
	color: black;
	font-size: 14px;
	-webkit-print-color-adjust: exact !important;
	color-adjust: exact !important;
}
/* Tamaño pagina 1056 1392 px  */
@media print {
	.no-display {
		display: none;
	}
	@page {
		size: 11in 14.5in;
		margin-top: 20px;
	}
}
.border-a {
	border-bottom: 2px solid gray !important ;
	margin-bottom: 2px;
}
.bl {
	border-left: 1px solid black;
}
.br {
	border-right: 1px solid black;
}
.bt {
	border-top: 1px solid black;
}
.bb {
	border-bottom: 1px solid black;
}
.bg {
	background-color: #c02030;
}
.bg-secondary {
	background-color: #a5c01352;
}
.cc {
	width: 30px;
	height: 15px;
}

.border-ot {
	background-color: white;
	/* border: 3px solid black; */
	margin: 0 auto;
	width: 98%;
	height: max-content;
	max-width: 1400px;
}
.foto-antecedentes {
	border-radius: 15px;
	margin-bottom: 50px;
	height: 200px;
	width: 200px;
	border: 1px solid black;
}
.btn {
	font-size: 14px;
	padding: 6px 12px;
	margin-bottom: 0;

	display: inline-block;
	text-decoration: none;
	text-align: center;
	white-space: nowrap;
	vertical-align: middle;
	-ms-touch-action: manipulation;
	touch-action: manipulation;
	cursor: pointer;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	background-image: none;
	border: 1px solid transparent;
}
.btn-default {
	color: #333;
	background-color: #fff;
	border-color: #ccc;
}
</style>
